import { GlRepository } from "../repositories/GlRepository";
import { GlOperationResult } from "../entities/GlEntity";

/**
 * Delete GL Use Case
 * Deletes a GL from Zoho and gl_map, or submits for review
 */
export class DeleteGlUseCase {
  constructor(private repository: GlRepository) {}

  async execute(
    accountId: string,
    payload?: { request_comments?: string }
  ): Promise<GlOperationResult> {
    return this.repository.deleteGl(accountId, payload);
  }
}
